import { render, staticRenderFns } from "./BillingAccounts.vue?vue&type=template&id=3b5d9c59&scoped=true&"
import script from "./BillingAccounts.vue?vue&type=script&lang=js&"
export * from "./BillingAccounts.vue?vue&type=script&lang=js&"
import style0 from "./BillingAccounts.vue?vue&type=style&index=0&id=3b5d9c59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d9c59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b5d9c59')) {
      api.createRecord('3b5d9c59', component.options)
    } else {
      api.reload('3b5d9c59', component.options)
    }
    module.hot.accept("./BillingAccounts.vue?vue&type=template&id=3b5d9c59&scoped=true&", function () {
      api.rerender('3b5d9c59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Billing/BillingAccounts.vue"
export default component.exports